import keyBy from 'lodash/keyBy';

import {qapiEventDefinitionsClient} from 'common/report/queries/query-api/legacy-event-definitions-client';
import {BaseClient} from 'common/report/queries/utils/base-client';
import type {EventDefinition} from 'common/util/definitions-types';

import {Store} from './store';

function getEventDefinitionKey(eventDefinition: EventDefinition) {
  const customEventId = eventDefinition.customEventId || eventDefinition.collectEverythingEventId;
  return customEventId ? `$custom_event:${customEventId}` : eventDefinition.name;
}

export const transform = {
  index: (definitions: EventDefinition[]) => keyBy(definitions, getEventDefinitionKey),
  update: (definition: EventDefinition) => ({k: getEventDefinitionKey(definition), v: definition}),
};

const client = qapiEventDefinitionsClient;

export const eventDefinitionsStore = new Store<{[eventName: string]: EventDefinition}, EventDefinition[]>({
  apiClient: client as BaseClient,
  defaultValue: {},
  name: `event-definitions`,
  transform,
});

export type EventDefinitionsStore = typeof eventDefinitionsStore;

export function findEventDefinitionByDisplayName(displayName: string) {
  return Object.values(eventDefinitionsStore.value).find((item) => item.displayName === displayName);
}
